module.exports = __webpack_public_path__ + "img/martini-glass-citrus.e8f9be89.svg";